module.exports = __webpack_public_path__ + "img/24-1.a1fcd516.png";